import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

type ChangePasswordParams = {
	OldPassword: string;
	NewPassword: string;
	ConfirmPassword: string;
};

const initialState = null;

export const { thunk: changePassword, slice: changePasswordSlice } = getThunkAndSlice<ChangePasswordParams, null>({
	initialState,
	path: "/api/Account/ChangePassword",
	method: "post",
});
